import { OnboardingModule } from "components/common/OnboardingModule";
import { OnboardingTask } from "components/common/OnboardingTypes";
import { useGetMemberDetails } from "services/member";
import { useEffect, useState } from "react";

export default () => {
  const { request: getMemberRequest, data } = useGetMemberDetails();
  const [memberDetails, setMemberDetails] = useState<any>(null);

  useEffect(() => {
    getMemberRequest();
  }, []);

  useEffect(() => {
    if (data) {
      setMemberDetails(data);
    }
  }, [data]);

  if (!memberDetails) return null;

  const tasks: OnboardingTask[] = [
    {
      label: "Complete your profile information",
      completed: !!(
        memberDetails.member?.firstName && memberDetails.member?.lastName
      ),
      url: "/settings?from=onboarding",
    },
    {
      label: "Add your first task for your advisor",
      completed: (memberDetails.tasks || []).some(
        (task: any) => task.creatorId === memberDetails.member?.id,
      ),
      url: "/tasks/add?from=onboarding",
    },
    {
      label: "Review and update your family information",
      completed: !!(
        memberDetails.family?.address && memberDetails.family?.name
      ),
      url: "/family-info?from=onboarding",
    },
    {
      label: "Set up your calendar integration",
      completed: false,
      url: "/settings/calendars?from=onboarding",
    },
    {
      label: "Invite family members to join",
      completed: (memberDetails.family?.members || []).length > 1,
      url: "/invite?from=onboarding",
    },
  ];

  return (
    <OnboardingModule
      tasks={tasks}
      title="Welcome to Faye! Get started"
      subtitle="Complete these steps to make the most of your Faye experience with your advisor."
      dismissKey="member-onboarding-dismissed"
      dismissDays={7}
      collapseSx={{ marginBottom: "0px" }}
    />
  );
};
